/**
 * Rose Kit PDP — variant selection + add to cart
 */
(function () {
  var root = document.querySelector('[data-rk-pdp]');
  if (!root) return;

  var jsonEl = root.querySelector('[data-rk-product-json]');
  if (!jsonEl) return;

  var product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  if (!product || !product.variants || !product.variants.length) return;

  var form = root.querySelector('.rk-pdp-form') || root.querySelector('#rk-pdp-product-form');
  var variantInput = root.querySelector('[data-rk-variant-id]');
  var priceEl = root.querySelector('[data-rk-price]');
  var atcBtn = root.querySelector('[data-rk-atc]');
  var atcLabelEl = root.querySelector('[data-rk-atc-label]');
  var errorEl = root.querySelector('[data-rk-error]');
  var offersEl = root.querySelector('[data-rk-offers]');
  var slotsEl = root.querySelector('[data-rk-slots]');
  var addonEl = root.querySelector('[data-rk-addon]');

  // ---- Offer model ------------------------------------------------------
  // The page no longer sells "a variant". It sells an offer: one kit or two,
  // each kit its own colour, with an optional single set of tools. Liquid hands
  // over the option names and prices; everything below composes cart line items
  // from them. `selected` is still maintained as the option map the gallery and
  // tools-copy code already understand, pointed at whichever kit is previewed.
  var colorOptionName  = slotsEl && slotsEl.getAttribute('data-rk-color-option');
  var configOptionName = slotsEl && slotsEl.getAttribute('data-rk-config-option');
  var configPlain      = slotsEl && slotsEl.getAttribute('data-rk-config-plain');
  var configTools      = slotsEl && slotsEl.getAttribute('data-rk-config-tools');
  function intAttr(name, fallback) {
    var n = slotsEl && parseInt(slotsEl.getAttribute(name), 10);
    return isNaN(n) ? fallback : n;
  }
  var pairPrice   = intAttr('data-rk-pair-price', 0);
  var singlePrice = intAttr('data-rk-single-price', 0);
  var toolsDelta  = intAttr('data-rk-tools-delta', 0);
  // The tools add-on is its own product, so the cart carries it as a separate
  // line. Zero when the section setting is empty, in which case buildLineItems
  // falls back to the old "& tools" variant swap.
  var toolsVariantId = intAttr('data-rk-tools-variant-id', 0);

  // Colour choices are read back off the server-rendered first step, so the
  // Ember-first ordering and the "Orange -> Ember" display label are defined in
  // exactly one place (Liquid) rather than duplicated here.
  var colorChoices = [];
  if (slotsEl) {
    Array.prototype.forEach.call(slotsEl.querySelectorAll('[data-option-value]'), function (b) {
      var v = b.getAttribute('data-option-value');
      if (colorChoices.some(function (c) { return c.value === v; })) return;
      var labelEl = b.querySelector('span:last-child');
      colorChoices.push({ value: v, label: (labelEl ? labelEl.textContent : v).trim() });
    });
  }
  var offer = 'pair';       // 'pair' | 'single'
  var tools = false;
  // Both kits start on the hero colourway, matching what Liquid rendered, so
  // the offer is complete on load and the button is live without a first click.
  var picks = { 1: null, 2: null };
  var previewSlot = 1;      // which kit the gallery is showing

  function slotsNeeded() { return offer === 'pair' ? 2 : 1; }
  function slotLabel(n) {
    if (offer === 'single') return 'KIT COLOR';
    return n === 1 ? 'KIT ONE COLOR' : 'KIT TWO COLOR';
  }
  function isReady() {
    for (var i = 1; i <= slotsNeeded(); i++) if (!picks[i]) return false;
    return true;
  }

  var optionNames = product.options || [];
  // Newer JSON may expose options as [{name, values}] — normalize to name strings
  if (optionNames.length && typeof optionNames[0] === 'object' && optionNames[0]) {
    optionNames = optionNames.map(function (opt) { return opt.name || opt; });
  }

  var selected = {};
  var current = product.variants.find(function (v) {
    return String(v.id) === String(variantInput && variantInput.value);
  }) || product.variants[0];

  if (current && current.options) {
    optionNames.forEach(function (name, i) {
      selected[name] = current.options[i];
    });
  }

  var defaultColor = (colorChoices[0] && colorChoices[0].value) ||
    (colorOptionName ? selected[colorOptionName] : null);
  picks[1] = defaultColor;
  picks[2] = defaultColor;

  // Keeps `selected` in step with the offer state. The gallery's syncMediaColor
  // and computeHasTools both read `selected`, so pointing it at the previewed
  // kit is what makes the photo follow the most recent colour choice without
  // touching any of the carousel code.
  function syncSelected() {
    if (colorOptionName) {
      selected[colorOptionName] = picks[previewSlot] || picks[1] || picks[2] || defaultColor;
    }
    if (configOptionName) {
      selected[configOptionName] = tools ? configTools : configPlain;
    }
  }

  function computeHasTools() {
    return Object.keys(selected).some(function (k) {
      return /tool/i.test(selected[k] || '');
    });
  }
  var hasToolsState = computeHasTools();

  function money(cents) {
    var amount = typeof cents === 'number' ? cents : parseInt(cents, 10);
    if (isNaN(amount)) return '';
    try {
      return (amount / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) {
      return '$' + (amount / 100).toFixed(2);
    }
  }

  function findVariant() {
    return product.variants.find(function (v) {
      return optionNames.every(function (name, i) {
        return v.options[i] === selected[name];
      });
    });
  }

  // Resolve the variant for one kit: a colour plus whether that line carries
  // the tools configuration.
  function variantFor(color, withTools) {
    if (!color) return null;
    var want = {};
    if (colorOptionName) want[colorOptionName] = color;
    if (configOptionName) want[configOptionName] = withTools ? configTools : configPlain;
    return product.variants.find(function (v) {
      return optionNames.every(function (name, i) {
        return !(name in want) || v.options[i] === want[name];
      });
    });
  }

  // One set of tools covers both builds, so the Pair adds only one. With the
  // add-on product configured the tools become their own line and both kits are
  // the plain configuration, so the order reads "Rose Kit $69" + "Soldering
  // Tools $20" rather than one combined $89 kit. Without it we fall back to the
  // old variant swap, where the tools ride on kit one's line.
  //
  // Two kits of the same colour collapse into a single line of quantity 2. The
  // Pair discount is scoped to the Rose Kit product and counts qualifying items
  // only, so that still reads as two, and the tools line never counts toward it
  // (one kit plus tools is two cart items but only one qualifying item, so it
  // correctly stays at full price).
  function buildLineItems() {
    var items = [];
    function push(variant) {
      if (!variant) return;
      for (var i = 0; i < items.length; i++) {
        if (items[i].id === Number(variant.id)) { items[i].quantity += 1; return; }
      }
      items.push({ id: Number(variant.id), quantity: 1 });
    }
    push(variantFor(picks[1], tools && !toolsVariantId));
    if (offer === 'pair') push(variantFor(picks[2], false));
    if (tools && toolsVariantId) items.push({ id: toolsVariantId, quantity: 1 });
    return items;
  }

  function offerTotal() {
    return (offer === 'pair' ? pairPrice : singlePrice) + (tools ? toolsDelta : 0);
  }

  // The founders batch is one shared pool across every variant, and overselling
  // is on so Shopify keeps reporting each variant as available past the cap.
  // Liquid decides whether the pool still has units and stamps the answer here;
  // without this gate, clicking any chip would re-enable a closed batch.
  var batchOpen = root.getAttribute('data-rk-batch-open') !== 'false';

  function isAvailable(variant) {
    if (!batchOpen) return false;
    if (!variant) return false;
    if (typeof variant.available === 'boolean') return variant.available;
    return true;
  }

  function shopRoot() {
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (rootPath.slice(-1) !== '/') rootPath += '/';
    return rootPath;
  }

  // "The tools" spec row carries one paragraph per configuration and shows
  // whichever matches the selection.
  var toolsCopies = Array.prototype.slice.call(root.querySelectorAll('[data-rk-tools-copy]'));

  // Both rows stay on screen; only the chip selection and the labels change, so
  // this updates the existing markup in place rather than replacing it. Slot two
  // is hidden outright when the offer is a single kit.
  function renderSlots() {
    if (!slotsEl) return;
    [1, 2].forEach(function (n) {
      var row = slotsEl.querySelector('[data-rk-slot-row="' + n + '"]');
      if (!row) return;
      row.hidden = n > slotsNeeded();
      var label = row.querySelector('.rk-pdp-colors__label');
      if (label) label.textContent = slotLabel(n);
      row.setAttribute('aria-label', slotLabel(n));
      Array.prototype.forEach.call(row.querySelectorAll('[data-option-value]'), function (btn) {
        var on = btn.getAttribute('data-option-value') === picks[n];
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    });
  }

  function updateUI() {
    syncSelected();
    var variant = findVariant() || product.variants[0];
    current = variant;
    if (variantInput) variantInput.value = variant.id;

    if (offersEl) {
      Array.prototype.forEach.call(offersEl.querySelectorAll('[data-rk-offer]'), function (btn) {
        var on = btn.getAttribute('data-rk-offer') === offer;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    renderSlots();

    if (addonEl) {
      addonEl.classList.toggle('is-checked', tools);
      addonEl.setAttribute('aria-checked', tools ? 'true' : 'false');
    }

    // Nothing can go to cart until every kit has a colour, so the button says
    // what is missing rather than offering a price for an incomplete order.
    var ready = isReady();
    var total = offerTotal();
    if (priceEl) {
      priceEl.textContent = money(total);
      priceEl.hidden = !batchOpen || !ready;
    }
    if (atcLabelEl) {
      atcLabelEl.textContent = !batchOpen ? 'Preorders closed'
        : !ready ? (offer === 'pair' ? 'Choose both colours' : 'Choose a colour')
        : 'Preorder';
    }
    if (atcBtn) {
      var ok = batchOpen && ready && isAvailable(variant);
      atcBtn.disabled = !ok;
      atcBtn.classList.toggle('is-disabled', !ok);
    }
    // Keep the PostHog price attribute on the real offer total, not one variant.
    if (form) form.setAttribute('data-ph-price', String(total));

    var hasTools = computeHasTools();
    if (hasTools !== hasToolsState) {
      hasToolsState = hasTools;
      rebuildDots();
      setMediaIndex(0);
      rebuildG2();
    }
    toolsCopies.forEach(function (el) {
      el.hidden = (el.getAttribute('data-rk-tools-copy') === 'tools') !== hasTools;
    });

    // Per-color galleries win; the variant featured-image swap only applies
    // when the selected color has no gallery of its own.
    var colorChanged = syncMediaColor();
    if (!colorChanged && variant.featured_image && variant.featured_image.id) {
      var eligible = eligibleSlides();
      eligible.forEach(function (slide, idx) {
        if (String(slide.getAttribute('data-media-id')) === String(variant.featured_image.id)) {
          setMediaIndex(idx);
        }
      });
    }

    if (variant && history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }
  }

  if (slotsEl) {
    slotsEl.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var chip = target.closest('[data-option-value]');
      if (!chip) return;
      var slot = parseInt(chip.getAttribute('data-rk-slot'), 10) || 1;
      picks[slot] = chip.getAttribute('data-option-value');
      previewSlot = slot;                             // gallery follows the last pick
      updateUI();
    });
  }

  if (offersEl) {
    Array.prototype.forEach.call(offersEl.querySelectorAll('[data-rk-offer]'), function (btn) {
      btn.addEventListener('click', function () {
        offer = btn.getAttribute('data-rk-offer');
        // Dropping to a single kit leaves the gallery pointed at a hidden slot.
        if (previewSlot > slotsNeeded()) previewSlot = 1;
        updateUI();
      });
    });
  }

  if (addonEl) {
    addonEl.addEventListener('click', function () {
      tools = !tools;
      updateUI();
    });
  }

  // Media carousel — slides can be grouped per color (data-color-group).
  // Only the active color's group plus ungrouped slides (product media,
  // placeholder) take part; the dots rebuild to match the active group.
  var mediaRoot = root.querySelector('[data-rk-media]');
  var mediaIndex = 0;
  var activeColor = null;
  var allSlides = mediaRoot
    ? Array.prototype.slice.call(mediaRoot.querySelectorAll('.rk-pdp-media__slide'))
    : [];
  var colorGroups = {};
  allSlides.forEach(function (s) {
    var g = s.getAttribute('data-color-group');
    if (g) colorGroups[g] = true;
  });

  // ---- Turntable: drag to spin pre-rendered Cycles frames ------------------
  // The gallery used to hold a live <model-viewer>. It was replaced because a
  // real-time glTF model cannot match Cycles - no subsurface in the LED lenses,
  // no area lights, no GI - so the board read either over-saturated or washed
  // out whatever the materials were set to. These frames ARE the render.
  //
  // Only the frame URLs are in the markup. A colourway's images are fetched the
  // first time it is actually shown or pointed at, so the two colours a shopper
  // never opens cost nothing.
  function wireTurntable(el) {
    if (el._rkTT) return;
    el._rkTT = true;
    var urls = (el.getAttribute('data-urls') || '').split(',').filter(Boolean);
    var img = el.querySelector('img');
    if (urls.length < 2 || !img) return;

    var idx = 0, primed = false, dragging = false, lastX = 0, carry = 0;
    var PX_PER_FRAME = 24;   // one step per 24px, so a full turn is ~575px of drag

    // Fetch the frames one at a time rather than firing all 24 at once. At
    // 2048px they are ~160KB each, so a parallel burst is ~4MB of simultaneous
    // requests and stalls the first frames behind the last on mobile data.
    // Sequential means the early frames land quickly and scrubbing is usable
    // while the rest stream in; anything not yet cached simply loads on demand
    // when show() points at it.
    function preload() {
      if (primed) return;
      primed = true;
      var n = 0;
      (function next() {
        if (n >= urls.length) return;
        var im = new Image();
        im.onload = im.onerror = next;
        im.src = urls[n++];
      })();
    }
    // The board's opaque top edge sits at ~31.3% of the frame height (measured
    // off the alpha of the rendered frames). Converting that to pixels needs the
    // PAINTED image box, not the element box: the frames are square and
    // object-fit:contain letterboxes them differently depending on whether the
    // slide is wider or taller than it is square.
    // The board's opaque top edge, measured off the alpha of each rendered
    // frame as a fraction of frame height. It is not a constant: the board
    // tips as it turns, so the top rides from 0.309 face-on to 0.273 at the
    // extremes. A single value left the hint sitting on the board at some
    // angles, which is why it is a table. Identical for all three colourways,
    // since only the LED colour differs, so one table serves them all.
    //
    // Regenerate if the turntable is re-rendered at a different frame count or
    // camera; the length check below falls back to the safe minimum.
    var BOARD_TOP_BY_FRAME = [
      0.3086, 0.3008, 0.2930, 0.2852, 0.2773, 0.2734, 0.2734, 0.2734,
      0.2773, 0.2852, 0.2930, 0.3008, 0.3086, 0.3008, 0.2930, 0.2852,
      0.2773, 0.2734, 0.2734, 0.2734, 0.2773, 0.2852, 0.2930, 0.3008
    ];
    var BOARD_TOP_MIN = 0.2734;   // highest the board ever reaches, so never overlaps
    function boardTop() {
      return BOARD_TOP_BY_FRAME.length === urls.length
        ? BOARD_TOP_BY_FRAME[idx]
        : BOARD_TOP_MIN;
    }
    function placeHint() {
      var r = img.getBoundingClientRect();
      var host = el.getBoundingClientRect();
      if (!r.height || !img.naturalHeight) return;
      var ar = img.naturalWidth / img.naturalHeight;
      var painted = (r.width / r.height) > ar ? r.height : r.width / ar;
      var offset = (r.height - painted) / 2;
      // Both rects are viewport-space, so subtracting host.top puts the result
      // in the container's own coordinates, which is what `top` resolves
      // against. Measuring off the image box alone was wrong below 1100px,
      // where .rk-pdp-media__frame scales the image 1.2x: getBoundingClientRect
      // reports the SCALED box, so the offset came out ~95px too large and
      // dropped the hint onto the board instead of above it.
      el.style.setProperty('--rk-tt-board-top',
        (r.top + offset + painted * boardTop() - host.top) + 'px');
    }
    if (img.complete) placeHint(); else img.addEventListener('load', placeHint);
    window.addEventListener('resize', placeHint);
    // A hidden slide has no box, so placeHint bails early; and if its frame was
    // already cached, no load event ever fires to retry. Watching the element
    // covers becoming visible on a colourway switch, the 1100px breakpoint flip
    // and plain window resizes in one go.
    if (window.ResizeObserver) new ResizeObserver(placeHint).observe(el);

    function show(i) {
      var n = urls.length;
      idx = ((i % n) + n) % n;
      img.src = urls[idx];
    }

    // Touch has to serve two horizontal gestures at once: spin the board, and
    // move to the next gallery image. They are told apart by SPEED - a
    // controlled drag rotates, a quick flick navigates.
    //
    // This replaced a hold-then-drag split, which failed on real hardware.
    // Nobody pauses before dragging, so in practice every gesture registered
    // as a swipe and the board simply never turned. Direction now decides
    // whether the gesture is ours at all; velocity decides what it meant.
    //
    // Mouse is unaffected: on desktop there is no swipe-to-navigate, the arrows
    // do that, so a drag rotates however fast it is.
    var FLICK_V = 0.6;     // px/ms across the tail of the gesture
    var FLICK_MIN = 50;    // and this much total travel, so a twitch is not a flick
    var SAMPLE_MS = 120;   // window the tail velocity is measured over
    var AXIS_MIN = 6;      // movement needed before the axis can be read
    var mode = null, startX = 0, startY = 0, startIdx = 0, isTouch = false;
    var samples = [];

    function endGesture() {
      dragging = false;
      mode = null;
      samples.length = 0;
      el.classList.remove('is-dragging');
      // The frame changed while the hint was hidden, and every frame puts the
      // board's top edge somewhere slightly different, so re-anchor before it
      // fades back in. Only once per gesture: during the drag it is invisible.
      placeHint();
    }

    // Velocity over the last SAMPLE_MS only. Measuring the whole gesture would
    // let a long slow spin that happens to end quickly read as a flick.
    function tailVelocity() {
      if (samples.length < 2) return 0;
      var first = samples[0], last = samples[samples.length - 1];
      var dt = last.t - first.t;
      return dt > 0 ? (last.x - first.x) / dt : 0;
    }

    el.addEventListener('pointerenter', preload);
    el.addEventListener('pointerdown', function (e) {
      // A second finger means the shopper is pinching to zoom, not spinning the
      // board. Only the first touch is primary, so this hands the gesture back
      // to the browser instead of turning the board while it zooms.
      if (!e.isPrimary) { endGesture(); return; }
      preload();
      dragging = true;
      lastX = startX = e.clientX;
      startY = e.clientY;
      carry = 0;
      startIdx = idx;
      isTouch = e.pointerType === 'touch';
      mode = isTouch ? null : 'rotate';   // mouse rotates from the first pixel
      if (!isTouch) el.classList.add('is-dragging');
      samples = [{ x: e.clientX, t: e.timeStamp }];
      if (el.setPointerCapture) { try { el.setPointerCapture(e.pointerId); } catch (err) {} }
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (mode === null) {
        if (Math.abs(dx) < AXIS_MIN && Math.abs(dy) < AXIS_MIN) return;
        // A mostly-vertical drag belongs to the page. touch-action:pan-y means
        // the browser is already scrolling it, so stay out of the way.
        mode = Math.abs(dx) > Math.abs(dy) ? 'rotate' : 'scroll';
        if (mode === 'rotate') el.classList.add('is-dragging');
      }
      if (mode !== 'rotate') { lastX = e.clientX; return; }

      samples.push({ x: e.clientX, t: e.timeStamp });
      while (samples.length > 2 && e.timeStamp - samples[0].t > SAMPLE_MS) samples.shift();

      carry += e.clientX - lastX;
      lastX = e.clientX;
      var steps = (carry / PX_PER_FRAME) | 0;
      if (steps) { carry -= steps * PX_PER_FRAME; show(idx + steps); }
    });

    // Hold the page still while the board is being turned. touch-action:pan-y
    // lets the browser scroll vertically, which is what we want at rest but
    // fights the gesture mid-spin: a little vertical drift and the page slides
    // away under the thumb. Once the gesture is a rotate, that scroll is
    // refused, so the drag has the screen to itself until the finger lifts.
    //
    // It has to be touchmove and it has to be non-passive: preventDefault on a
    // pointermove does not stop scrolling, and a passive listener is not
    // allowed to preventDefault at all. pointermove runs first, so mode is
    // already decided by the time this fires. Once the browser has committed
    // to a scroll the event stops being cancelable, hence the guard.
    el.addEventListener('touchmove', function (e) {
      if (mode === 'rotate' && e.cancelable) e.preventDefault();
    }, { passive: false });

    el.addEventListener('pointerup', function (e) {
      // Only touch navigates by flick; on desktop that is the arrows' job.
      if (dragging && mode === 'rotate' && isTouch) {
        var dx = e.clientX - startX;
        if (Math.abs(tailVelocity()) >= FLICK_V && Math.abs(dx) >= FLICK_MIN) {
          // The board turned while the finger moved, so put it back before
          // leaving. The slide is hidden by then, so the reset is never seen.
          show(startIdx);
          setMediaIndex(mediaIndex + (dx < 0 ? 1 : -1));
        }
      }
      endGesture();
    });
    // pointerleave is deliberately NOT an ender. setPointerCapture can fail,
    // and then dragging a finger past the edge of the board would kill the spin
    // mid-turn, which on a phone is most of the way across the board.
    el.addEventListener('pointercancel', endGesture);
    // Released outside the element (capture failed), so el never sees pointerup
    // and would stay armed. The flick is lost in that case, but the drag ends.
    window.addEventListener('pointerup', function () { if (dragging) endGesture(); });

    // Never swallow the wheel: scrolling over the gallery must still move the
    // page, which is why the 3D viewer's zoom was turned off too.
    if (el.closest && el.closest('.rk-pdp-media__slide.is-eligible')) preload();
  }

  // Swipe to change image, for the slides that are not the turntable. The
  // turntable runs its own gesture handling (drag spins, flick navigates), so
  // anything starting inside one is left alone. Without this the photo slides
  // had no touch handling at all: a flick off the turntable stranded you there
  // with no way back except the arrows.
  function wireSwipe(frame) {
    if (!frame || frame._rkSwipe) return;
    frame._rkSwipe = true;
    var SWIPE_MIN = 40;   // px of horizontal travel before it counts as a swipe
    var AXIS_MIN = 6;     // movement needed before the axis can be read
    var live = false, sx = 0, sy = 0, axis = null;

    frame.addEventListener('pointerdown', function (e) {
      // Touch only: on desktop the arrows do this, and a mouse drag across a
      // photo should not navigate. Non-primary means a pinch is starting.
      if (e.pointerType !== 'touch' || !e.isPrimary) { live = false; return; }
      if (e.target.closest && e.target.closest('[data-rk-turntable]')) return;
      live = true; axis = null; sx = e.clientX; sy = e.clientY;
      if (frame.setPointerCapture) { try { frame.setPointerCapture(e.pointerId); } catch (err) {} }
    });

    frame.addEventListener('pointermove', function (e) {
      if (!live || axis !== null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) < AXIS_MIN && Math.abs(dy) < AXIS_MIN) return;
      // A mostly-vertical drag is the page scrolling; leave it be.
      axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    });

    frame.addEventListener('pointerup', function (e) {
      if (live && axis === 'x') {
        var dx = e.clientX - sx;
        if (Math.abs(dx) >= SWIPE_MIN) setMediaIndex(mediaIndex + (dx < 0 ? 1 : -1));
      }
      live = false;
    });
    frame.addEventListener('pointercancel', function () { live = false; });
  }

  if (mediaRoot) {
    Array.prototype.forEach.call(
      mediaRoot.querySelectorAll('[data-rk-turntable]'), wireTurntable);
    Array.prototype.forEach.call(
      mediaRoot.querySelectorAll('.rk-pdp-media__frame'), wireSwipe);
  }

  // Second gallery (after the rose): a flip carousel of the "all colors"
  // photos. The tools-only slide joins only when a tools config is selected.
  // Desktop uses its own flip index/dots; mobile folds these into the main
  // carousel (the wrapper is display:contents), so eligibleSlides also gates
  // the tools slide by selection.
  var gallery2 = mediaRoot ? mediaRoot.querySelector('[data-rk-gallery2]') : null;
  var g2Slides = gallery2
    ? Array.prototype.slice.call(gallery2.querySelectorAll('.rk-pdp-media__slide'))
    : [];
  var g2Idx = 0;
  function g2Visible() {
    return g2Slides.filter(function (s) {
      return !(s.getAttribute('data-config-media') === 'tools' && !hasToolsState);
    });
  }
  function setG2(i) {
    var vis = g2Visible();
    if (!vis.length) return;
    g2Idx = ((i % vis.length) + vis.length) % vis.length;
    g2Slides.forEach(function (s) { s.classList.toggle('is-g2-active', s === vis[g2Idx]); });
    if (!gallery2) return;
    var dots = gallery2.querySelectorAll('.rk-pdp-media__g2-dot');
    Array.prototype.forEach.call(dots, function (d, j) { d.classList.toggle('is-active', j === g2Idx); });
    var thumbs = gallery2.querySelectorAll('.rk-pdp-media__g2-thumb');
    Array.prototype.forEach.call(thumbs, function (t, j) {
      var on = j === g2Idx;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }
  function rebuildG2() {
    if (!gallery2) return;
    var vis = g2Visible();
    var controls = gallery2.querySelector('.rk-pdp-media__gallery2-controls');
    if (controls) controls.style.display = vis.length > 1 ? '' : 'none';
    var dotsWrap = gallery2.querySelector('[data-rk-g2-dots]');
    if (dotsWrap) {
      while (dotsWrap.firstChild) dotsWrap.removeChild(dotsWrap.firstChild);
      vis.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'rk-pdp-media__g2-dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Photo ' + (i + 1));
        d.addEventListener('click', function () { setG2(i); });
        dotsWrap.appendChild(d);
      });
    }
    // Thumbnails mirror the dots, but show the actual photo so a second frame
    // is obviously a different shot. Reusing the slide's own src (currentSrc
    // once it has loaded) keeps this to a cache hit rather than a new request.
    var thumbsWrap = gallery2.querySelector('[data-rk-g2-thumbs]');
    if (thumbsWrap) {
      thumbsWrap.style.display = vis.length > 1 ? '' : 'none';
      while (thumbsWrap.firstChild) thumbsWrap.removeChild(thumbsWrap.firstChild);
      vis.forEach(function (slide, i) {
        var slideImg = slide.querySelector('img');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rk-pdp-media__g2-thumb' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Show photo ' + (i + 1));
        if (slideImg) {
          var im = document.createElement('img');
          im.src = slideImg.currentSrc || slideImg.src;
          im.alt = '';
          im.loading = 'lazy';
          im.decoding = 'async';
          b.appendChild(im);
        }
        b.addEventListener('click', function () { setG2(i); });
        thumbsWrap.appendChild(b);
      });
    }
    setG2(0);
  }
  if (gallery2) {
    var g2prev = gallery2.querySelector('[data-rk-g2-prev]');
    var g2next = gallery2.querySelector('[data-rk-g2-next]');
    if (g2prev) g2prev.addEventListener('click', function () { setG2(g2Idx - 1); });
    if (g2next) g2next.addEventListener('click', function () { setG2(g2Idx + 1); });
    rebuildG2();
  }

  function eligibleSlides() {
    return allSlides.filter(function (s) {
      var g = s.getAttribute('data-color-group');
      if (g && g !== activeColor) return false;
      if (s.getAttribute('data-config-media') === 'tools' && !hasToolsState) return false;
      return true;
    });
  }

  function setMediaIndex(i) {
    if (!mediaRoot) return;
    var slides = eligibleSlides();
    var dots = mediaRoot.querySelectorAll('.rk-pdp-media__dot');
    if (!slides.length) return;
    mediaIndex = ((i % slides.length) + slides.length) % slides.length;
    allSlides.forEach(function (s) {
      s.classList.toggle('is-active', s === slides[mediaIndex]);
    });
    dots.forEach(function (d, idx) {
      d.classList.toggle('is-active', idx === mediaIndex);
    });
  }

  function rebuildDots() {
    if (!mediaRoot) return;
    var dotsWrap = mediaRoot.querySelector('[data-rk-media-dots]');
    var controls = mediaRoot.querySelector('.rk-pdp-media__controls');
    var elig = eligibleSlides();
    // Desktop shows eligible slides as a scrolling stack (no carousel), so
    // eligibility must be a class the stylesheet can see.
    allSlides.forEach(function (s) {
      s.classList.toggle('is-eligible', elig.indexOf(s) !== -1);
    });
    var count = elig.length;
    if (controls) controls.style.display = count > 1 ? '' : 'none';
    if (!dotsWrap) return;
    while (dotsWrap.firstChild) dotsWrap.removeChild(dotsWrap.firstChild);
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'rk-pdp-media__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('data-index', String(i));
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      dot.addEventListener('click', function () {
        setMediaIndex(parseInt(this.getAttribute('data-index'), 10) || 0);
      });
      dotsWrap.appendChild(dot);
    }
  }

  // Returns true when the selection maps to a color and it changed. Once we
  // learn which option is the color one (its value matched a group), colors
  // without uploads still switch — to just the ungrouped slides.
  var colorOptionName = null;
  function syncMediaColor() {
    var color = null;
    for (var name in selected) {
      if (colorGroups[selected[name]]) {
        color = selected[name];
        colorOptionName = name;
      }
    }
    if (!color && colorOptionName) color = selected[colorOptionName];
    if (!color || color === activeColor) return false;
    activeColor = color;
    rebuildDots();
    setMediaIndex(0);
    return true;
  }

  if (mediaRoot) {
    var prev = mediaRoot.querySelector('[data-rk-media-prev]');
    var next = mediaRoot.querySelector('[data-rk-media-next]');
    if (prev) prev.addEventListener('click', function () { setMediaIndex(mediaIndex - 1); });
    if (next) next.addEventListener('click', function () { setMediaIndex(mediaIndex + 1); });
    rebuildDots();
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!batchOpen || !isReady()) return;
      var items = buildLineItems();
      if (!items.length) return;
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (atcBtn) atcBtn.disabled = true;

      var rootPath = shopRoot();

      // Always end with exactly this offer and nothing else: clear the cart,
      // then add its line items. The Pair is two lines (or one of quantity 2
      // when both kits share a colour), which is also what makes the automatic
      // "2 items" order discount apply and turn 2 x kit price into the pair
      // price. Without that discount the cart charges full price.
      fetch(rootPath + 'cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw { message: 'Could not reset cart.' };
          return fetch(rootPath + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function () {
          window.location.href = rootPath + 'checkout';
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = (err && (err.description || err.message)) || 'Could not start checkout. Please try again.';
          }
          if (atcBtn) atcBtn.disabled = !(batchOpen && isReady() && isAvailable(current));
        });
    });
  }

  updateUI();
})();
